import { createRouter, createWebHistory } from "vue-router";
const HomeView = () => import(/* webpackChunkName: "home" */ "../views/HomeView.vue");
const departmentsView = () => import(/* webpackChunkName: "departments", webpackPrefetch: true */ "../views/departmentsView.vue");
const favView = () => import(/* webpackChunkName: "fav" */ "../views/favView.vue");
const contactView = () => import(/* webpackChunkName: "contact" */ "../views/contactView.vue");
const catogryView = () => import(/* webpackChunkName: "category" */ "../views/catogryView.vue");
const catogryDetails = () => import(/* webpackChunkName: "category" */ "../views/catogryDetails.vue");
const favDetails = () => import(/* webpackChunkName: "fav" */ "../views/favDetails.vue");
const editProfileView = () => import(/* webpackChunkName: "profile" */ "../views/editProfileView.vue");
const ratingView = () => import(/* webpackChunkName: "rating" */ "../views/ratingView.vue");
const advertisementsView = () => import(/* webpackChunkName: "my-ads", webpackPrefetch: true */ "../views/advertisementsView.vue");
const notificationsView = () => import(/* webpackChunkName: "notifications" */ "../views/notificationsView.vue");
const conditionsView = () => import(/* webpackChunkName: "static" */ "../views/conditionsView.vue");

const uploadAds = () => import(/* webpackChunkName: "upload-ad", webpackPrefetch: true */ "../views/uploadAd.vue");
const adsPayment = () => import(/* webpackChunkName: "payment" */ "../views/adsPayment.vue");
const bannerPayment = () => import(/* webpackChunkName: "payment" */ "../views/bannerPayment.vue");
const successedPaid = () => import(/* webpackChunkName: "payment" */ "../views/successedPaid.vue");
const failedPaid = () => import(/* webpackChunkName: "payment" */ "../views/failedPaid.vue");
const bannerView = () => import(/* webpackChunkName: "banners" */ "../views/bannerView.vue");
const successAd = () => import(/* webpackChunkName: "upload-ad" */ "../views/succesAd.vue");
const profileView = () => import(/* webpackChunkName: "profile" */ "../views/profileView.vue");
const republishAdd = () => import(/* webpackChunkName: "upload-ad" */ "../views/republishAdd.vue");
const componiesView = () => import(/* webpackChunkName: "companies" */ "../views/componiesView.vue");
const companyDetails = () => import(/* webpackChunkName: "companies" */ "../views/companyDetails.vue");
const notFoundView = () => import(/* webpackChunkName: "not-found" */ "../components/NotFound/notFoundView.vue");
const publicAds = () => import(/* webpackChunkName: "public-ads" */ "../views/publicAds.vue");
const searchResults = () => import(/* webpackChunkName: "search" */ "../views/searchResults.vue");

const buyPrivacy = () => import(/* webpackChunkName: "static" */ "../views/buyPrivacy.vue");
const single_banner_view = () => import(/* webpackChunkName: "banners" */ "../views/single_banner_view.vue");
const single_banner_show = () => import(/* webpackChunkName: "banners" */ "../views/single_banner_show.vue");
const edit_advertisement = () => import(/* webpackChunkName: "upload-ad" */ "../views/edit_advertisement.vue");
const maintenanceSettings = () => import(/* webpackChunkName: "maintenance" */ "../views/maintenanceSettings.vue");
const MockPayment = () => import(/* webpackChunkName: "payment" */ "../views/MockPayment.vue");



const routes = [
  {
    path: '/maintenance',
    name: 'maintenanceSettings',
    component: maintenanceSettings,
    meta: { requiresAuth: true }
  },
  {
    path: '/search',
    name: 'searchResults',
    component: searchResults
  },
  {
    path: '/buyPrivacy',
    name: 'buyPrivacy',
    component: buyPrivacy
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/depatments",
    name: "departments",
    component: departmentsView,
  },
  {
    path: "/favView",
    name: "favView",
    component: favView,
    meta: { requiresAuth: true }
  },
  {
    path: "/contactView",
    name: "contactView",
    component: contactView,
  },
  {
    path: "/catogryView/:id",
    name: "catogryView",
    component: catogryView,
  },
  {
    path: "/catogryDetails/:id",
    name: "catogryDetails",
    component: catogryDetails,
  },
  {
    path: "/favDetails/:id",
    name: "favDetails",
    component: favDetails,
  },
  {
    path: "/editProfileView",
    name: "editProfileView",
    component: editProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: "/ratingView",
    name: "ratingView",
    component: ratingView,
  },
  {
    path: "/advertisementsView",
    name: "advertisementsView",
    component: advertisementsView,
    meta: { requiresAuth: true }
  },
  {
    path: "/notificationsView",
    name: "notificationsView",
    component: notificationsView,
  },
  {
    path: "/uploadAds",
    name: "uploadAds",
    component: uploadAds,
    meta: { requiresAuth: true }

  },
  {
    path: "/adsPayment",
    name: "adsPayment",
    component: adsPayment,
    meta: { hideFooter: true }
  },
  {
    path: "/successAd",
    name: "successAd",
    component: successAd,
  },
  {
    path: "/conditionsView",
    name: "conditionsView",
    component: conditionsView,
  },
  {
    path: "/profileView/:id",
    name: "profileView",
    component: profileView,
  },
  {
    path: "/republishAdd",
    name: "republishAdd",
    component: republishAdd,
  },
  {
    path: "/componiesView",
    name: "componiesView",
    component: componiesView,
  },
  {
    path: "/company/:id",
    name: "companyDetails",
    component: companyDetails,
  },

  {
    path: '/publicAds/:id',
    name: 'publicAds',
    component: publicAds
  },
  {
    path: '/bannerPayment',
    name: 'bannerPayment',
    component: bannerPayment,
    meta: { hideFooter: true }
  },
  {
    path: '/successed-payment',
    name: 'successedPaid',
    component: successedPaid,
    meta: { hideFooter: true }
  },
  {
    path: '/failed-payment',
    name: 'failedPaid',
    component: failedPaid,
    meta: { hideFooter: true }
  },
  {
    path: '/mock-payment',
    name: 'MockPayment',
    component: MockPayment,
    meta: { hideFooter: true }
  },
  {
    path: '/bannerView',
    name: 'bannerView',
    component: bannerView
  },
  {
    path: '/single_banner_view/:id',
    name: 'single_banner_view',
    component: single_banner_view
  },
  {
    path: '/single_banner_show/:id',
    name: 'single_banner_show',
    component: single_banner_show
  },
  {
    path: '/edit_advertisement/:id',
    name: 'edit_advertisement',
    component: edit_advertisement
  },
  {
    path: '/:catchAll(.*)*',
    name: "notFoundView",
    component: notFoundView,
  },
];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  }
});


router.beforeEach((to, from, next) => {
  // Global maintenance check
  const maintenanceEnabled = localStorage.getItem('maintenance_enabled') === 'true';
  const loginDisabled = localStorage.getItem('login_disabled') === 'true';
  const token = sessionStorage.getItem('token');

  if ((maintenanceEnabled || loginDisabled) && token) {
    // If maintenance is on or login is disabled and user is logged in, force logout logic
    // We let the App.vue poller handle the actual cleanup/alert to avoid duplication loop,
    // but we can block navigation to protected routes here.
    if (to.matched.some(record => record.meta.requiresAuth)) {
       next({ name: 'home' });
       return;
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'home' });
    } else {
      next();
    }
  } else {
    next();
  }
})




export default router;
